<div class="split-comparison-container">
  <app-face-compare-loader
    [isLoading]="currentLoadingState.isLoading"
    [loadingText]="currentLoadingState.loadingText">
  </app-face-compare-loader>

  <div class="comparison-header">
    <h2 class="comparison-title">Split Compare</h2>
    <div class="comparison-selectors-and-close-button">
      <div class="comparison-selectors">
        <div class="custom-dropdown" (click)="toggleDropdown1()" [class.active]="isDropdown1Open">
          <div class="dropdown-selected">
            <span>Image {{ selectedImage1 + 1 }}</span>
            <i class="bi bi-chevron-down dropdown-arrow"></i>
          </div>
          <div class="dropdown-options" *ngIf="isDropdown1Open">
            <div *ngFor="let image of availableImages; let i = index"
                 class="dropdown-option"
                 [class.selected]="i === selectedImage1"
                 (click)="selectImage1(i)">
              Image {{ i + 1 }}
            </div>
          </div>
        </div>
        <span class="vs-text">vs</span>
        <div class="custom-dropdown" (click)="toggleDropdown2()" [class.active]="isDropdown2Open">
          <div class="dropdown-selected">
            <span>Image {{ selectedImage2 + 1 }}</span>
            <i class="bi bi-chevron-down dropdown-arrow"></i>
          </div>
          <div class="dropdown-options" *ngIf="isDropdown2Open">
            <div *ngFor="let image of availableImages; let i = index"
                 class="dropdown-option"
                 [class.selected]="i === selectedImage2"
                 (click)="selectImage2(i)">
              Image {{ i + 1 }}
            </div>
          </div>
        </div>
      </div>
      <button class="close-button" (click)="onClose()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <div class="comparison-area"
       (mousemove)="onSplitDrag($event)"
       (mouseup)="endSplitDrag()"
       (mouseleave)="endSplitDrag()">

    <div class="image-panel"
         [style.clip-path]="'inset(0 ' + (100 - splitPosition) + '% 0 0)'"
         (wheel)="onWheel($event, 1)">
      <img
        [src]="getImage(selectedImage1)"
        [alt]="'Image ' + (selectedImage1 + 1)"
        class="comparison-image"
        [style.transform]="'scale(' + image1Zoom + ') translate(' + image1PanX + 'px, ' + image1PanY + 'px)'"
        (mousedown)="startPan($event, 1)"
        (mousemove)="onPan($event, 1)"
        (mouseup)="endPan(1)"
        (mouseleave)="endPan(1)"
        #image1>
    </div>

    <div class="image-panel"
         [style.clip-path]="'inset(0 0 0 ' + splitPosition + '%)'"
         (wheel)="onWheel($event, 2)">
      <img
        [src]="getImage(selectedImage2)"
        [alt]="'Image ' + (selectedImage2 + 1)"
        class="comparison-image"
        [style.transform]="'scale(' + image2Zoom + ') translate(' + image2PanX + 'px, ' + image2PanY + 'px)'"
        (mousedown)="startPan($event, 2)"
        (mousemove)="onPan($event, 2)"
        (mouseup)="endPan(2)"
        (mouseleave)="endPan(2)"
        #image2>
    </div>

    <div class="split-slider"
         [style.left]="splitPosition + '%'"
         (mousedown)="startSplitDrag($event)">
      <div class="split-handle">
        <div class="handle-circle">
          <i class="bi bi-chevron-left"></i>
          <i class="bi bi-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="control-panel">
    <div class="image-controls">
      <div class="zoom-controls">
        <label class="zoom-label">Zoom</label>
        <input
          type="range"
          class="zoom-slider"
          min="0.5"
          max="10"
          step="0.1"
          [(ngModel)]="image1Zoom"
          (input)="onZoomChange(1, $event)">
        <span class="zoom-value">{{ image1Zoom }}x</span>
      </div>
      <div class="button-group">
        <!-- Face enhance temporarily disabled
        <button class="enhance-btn" (click)="onEnhance(1)">
          Enhance
        </button>
        -->
        <button class="reset-btn" (click)="resetImage(1)">
          Reset
        </button>
      </div>
    </div>

    <div class="image-controls">
      <div class="zoom-controls">
        <label class="zoom-label">Zoom</label>
        <input
          type="range"
          class="zoom-slider"
          min="0.5"
          max="10"
          step="0.1"
          [(ngModel)]="image2Zoom"
          (input)="onZoomChange(2, $event)">
        <span class="zoom-value">{{ image2Zoom }}x</span>
      </div>
      <div class="button-group">
        <!-- Face enhance temporarily disabled
        <button class="enhance-btn" (click)="onEnhance(2)">
          Enhance
        </button>
        -->
        <button class="reset-btn" (click)="resetImage(2)">
          Reset
        </button>
      </div>
    </div>
  </div>
</div>
